import { render, staticRenderFns } from "./ResourcesTeamlist.vue?vue&type=template&id=4dc55bbe&"
import script from "./ResourcesTeamlist.vue?vue&type=script&lang=js&"
export * from "./ResourcesTeamlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports